// extracted by mini-css-extract-plugin
export default {"skills-container":"Skills_skills-container__-gtkW"};